export default {"src":"/_next/static/media/waypoint_on-light.f461fa12.svg","height":72,"width":252,"blurWidth":0,"blurHeight":0};